export default __webpack_public_path__ + "static/media/giraffe.af57268a.svg";